import React from "react";
import PubSub from "pubsub-js";
import { css } from "emotion";
import { Dropdown, Select, Label } from "@maxmilhas/hangar-components-atomic/public";
import { passengers, item, helper } from "./style";

import "../../../shared/pubsub-triggers";

class PassengersDropdown extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      adults: 1,
      children: 0,
      infants: 0,
      cabin: 'EC',
      isPassengersOpen: false
    }

    this.onChange = this.onChange.bind(this);
    this.renderText = this.renderText.bind(this);
  }

  renderText() {
    const { adults, children, infants, cabin} = this.state;
    const totalPassengers = adults + children + infants;
    const cabinTranslate = cabin === 'EC' ? "econômica" : "executiva";
    const noAdults = adults == 0
    const noChildren = children == 0;
    const noInfants = infants == 0;

    if (adults == 1 && noChildren && noInfants) {
      return `${adults} Adulto - ${cabinTranslate}`
    }

    if (adults > 0 && noChildren && noInfants) {
      return `${totalPassengers} Adultos - ${cabinTranslate}`
    }

    if (totalPassengers > 1) {
      return `${totalPassengers} Passageiros - ${cabinTranslate}`
    }

    return "Passageiros"
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.name !== "cabin" ? parseInt(event.target.value, 10) : event.target.value
    }, () => { this.props.getValue(this.state) })
  }

  render() {
    const { hasError: { infants: infantsError } } = this.props;
    const { isPassengersOpen } = this.state;
    
    return (
      <Dropdown
        style={{outline: 'none'}}
        tabIndex="-1"
        label="Passageiros e classe do voo"
        shadow={true}
        text={this.renderText()}
        hasError={infantsError}
        data-flow="down"
        data-tooltip={!isPassengersOpen && infantsError ? "Existem erros na seleção de passageiros. Corrija-os para prosseguir." : ""}
        aria-label={infantsError && "Existem erros na seleção de passageiros. Corrija-os para prosseguir."}
        aria-invalid={typeof infantsError === "string"}
        onOpen={() => this.setState({ isPassengersOpen: true })}
        onClose={() => this.setState({ isPassengersOpen: false })}
      >
        <div className={css`${passengers}`}>
          <div className={css`${item}`}>
            <Label form="adults">Adultos</Label>
            <Select id="adults" name="adults" onChange={this.onChange} data-action="maxairbridge-form-passengers-adults">
              <option value={1} defaultValue>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
              <option value={6}>6</option>
              <option value={7}>7</option>
              <option value={8}>8</option>
              <option value={9}>9</option>
            </Select>
          </div>
          <div className={css`${item}`}>
            <Label for="children">
              Crianças
              <span className={css`${helper}`}>2 a 11 anos</span>
            </Label>
            <Select id="children" name="children" onChange={this.onChange} data-action="maxairbridge-form-passengers-children">
              <option value={0} defaultValue>0</option>
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
              <option value={6}>6</option>
              <option value={7}>7</option>
              <option value={8}>8</option>
              <option value={9}>9</option>
            </Select>
          </div>
          <div className={css`${item}`} data-tooltip={this.props.hasError.infants} data-flow="down">
            <Label for="infants">
              Bebês
              <span className={css`${helper}`}>0 a 23 meses</span>
            </Label>
            <Select
              id="infants"
              name="infants"
              onChange={this.onChange}
              hasError={this.props.hasError.infants}
              data-action="maxairbridge-form-passengers-infants"
              aria-label={this.props.hasError.infants}
              aria-invalid={typeof this.props.hasError.infants === "string"}>
              <option value={0} defaultValue>0</option>
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
              <option value={6}>6</option>
              <option value={7}>7</option>
              <option value={8}>8</option>
              <option value={9}>9</option>
            </Select>
          </div>
        </div>
        <Select label="Classe do voo" id="cabin" name="cabin" onChange={this.onChange} data-action="maxairbridge-form-cabin">
            <option value="EC" defaultValue>Classe econômica</option>
            <option value="EX">Classe executiva</option>
        </Select>
      </Dropdown>
    )
  }
}

export default PassengersDropdown
